import { useMemo } from "react";
import { Guid } from "shared/models/HelperModels";
import { newGuid } from "shared/utils/newId";

export default function useId(): Guid {
	return useMemo(() => newGuid(), []);
}
